import { Injectable } from '@angular/core';
import { ReflectionService } from './reflection.service';

@Injectable({
    providedIn: 'root'
})
export class DateService {
    constructor(private reflection: ReflectionService) {}

    clearTime(date: Date): Date {
        if (date) {
            date.setHours(0, 0, 0, 0);
        }
        return date;
    }

    todayAtMidnight(): Date {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }

    parseStringToDate(dateString: string): Date {
        if (this.reflection.isNullOrEmpty(dateString)) {
            return null;
        }
        const d: Date = new Date(dateString);
        if (dateString.endsWith('Z')) {
            d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        }
        return d;
    }
}
